import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { fieldTypeName } from '@/constants/fields';
import { lookupFieldTypes } from '../../constants';

const listItems = (intl) => lookupFieldTypes.map((item) => (
  {
    key: item,
    text: intl.formatMessage({ id: fieldTypeName(item) }),
    value: item,
  }
));

const LookupTypeDropdown = ({ lookupType, onChange, className }) => {
  const intl = useIntl();
  return (
    <Dropdown
      id="lookup_type_dropdown"
      options={listItems(intl)}
      value={lookupType}
      fluid
      selection
      onChange={(e, { value }) => { onChange(value); }}
      className={clsx('aridhia-lookup-type-filter', className)}
    />
  );
};

export default LookupTypeDropdown;
